import {
  Form, FormProps, Label, Stack,
} from '@doveit/bricks';
import React from 'react';
import validationSchema from './GoalTargetForm.schema';

export interface GoalTargetFormModel {
  target: string,
}

export interface GoalTargetFormProps {
  initialValues?: Partial<GoalTargetFormModel>,
  minTarget: number,
  loading?: FormProps<GoalTargetFormModel>['loading'],
  onSubmit: FormProps<GoalTargetFormModel>['onSubmit'],
}

export const GoalTargetForm: React.FC<GoalTargetFormProps> = ({
  initialValues,
  loading,
  minTarget,
  onSubmit,
}) => {
  const mergedInitialValues: GoalTargetFormModel = React.useMemo(() => ({
    target: '',
    ...initialValues,
  }), [initialValues]);

  return (
    <Stack gap={150}>
      <Label text="Importo obiettivo" />
      <Form
        aria-label="Modulo per simulare l'obiettivo di guadagno"
        initialValues={mergedInitialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema(minTarget)}
        loading={loading}
      >
        <Form.Item size={3 / 4}>
          <Form.PriceField
            aria-label="Campo per inserire l'obiettivo di guadagno"
            name="target"
            placeholder="Es. 20.000"
          />
        </Form.Item>
        <Form.Item size={1 / 4}>
          <Form.Submit
            aria-label="Pulsante per avviare la simulazione dell'obiettivo di guadagno"
            label="Simula"
            color="neutral"
            width="100%"
          />
        </Form.Item>
      </Form>
    </Stack>
  );
};

export default GoalTargetForm;
